import React from 'react';
import { clsx} from 'clsx';
import { twMerge} from 'tailwind-merge';

/**
 * Utility for merging tailwind classes properly
 */
function cn(...inputs) {
 return twMerge(clsx(inputs));
}

const Card = React.forwardRef(({ className, children, padding = 'p-6', ...props}, ref) => {
 return (
 <div
 ref={ref}
 className={cn(
 "border rounded-lg transition-all duration-150 bg-white border-[#E5E5E5] shadow-[0_1px_3px_rgba(0,0,0,0.08)]",
 padding,
 className
 )}
 {...props}
 >
 {children}
 </div>
 );
});

Card.displayName = 'Card';

export default Card;

export { Card};
